export default "__VITE_ASSET__Cz_uW895__"